<div class="flex flex-dir-vert w-100 m-b-20">
  <div [ngClass]="{'order-send-to-bottom': mode=='tab'}">
    <div nz-row>
      <div nz-col nzXs="24" class="stage-wizard-sec">
  
        <app-stage-timeline [workQueueItem]="inputData"></app-stage-timeline>

        <div *ngIf="false">
          <!-- Stage -->
          <h3 class="heading heading-summary m-b-20 m-t-0-force">Current Workflow Stage</h3>
  
          <div class="stage-indicator">
            <nz-steps nzLabelPlacement="vertical" nzSize="default">
              <nz-step nzStatus="process" nzTitle="Completed" nzIcon="check" [nzDescription]="tmplCompleted"></nz-step>
              <nz-step nzStatus="process" nzTitle="Ongoing" nzIcon="loading" [nzDescription]="tmplOngoing"></nz-step>
              <nz-step nzTitle="Pending" nzIcon="hourglass" [nzDescription]="tmplPending" nzStatus="process"></nz-step>
              <!--Templates-->
              <ng-template #tmplCompleted>
                <ul class="ul-arrow">
                  <li><i style="padding-right: 5px" nz-icon nzType="check-circle" nzTheme="twotone"
                      twoToneColor="green"></i>Data
                    Entry</li>
                  <li><i style="padding-right: 5px" nz-icon nzType="check-circle" nzTheme="twotone"
                      twoToneColor="green"></i>Verification</li>
                  <li><i style="padding-right: 5px" nz-icon nzType="check-circle" nzTheme="twotone"
                      twoToneColor="green"></i>Payment
                  </li>
                  <li><i style="padding-right: 5px" nz-icon nzType="check-circle" nzTheme="twotone"
                      twoToneColor="green"></i>Auto
                    Underwriting</li>
                </ul>
              </ng-template>
              <ng-template #tmplOngoing>
                <ul class="ul-arrow">
                  <li><i style="padding-right: 5px" nz-icon nzType="info-circle" nzTheme="twotone"
                      twoToneColor="orange"></i>Manual
                    Underwriting</li>
                </ul>
              </ng-template>
              <ng-template #tmplPending>
                <ul class="ul-arrow">
                  <li><i style="padding-right: 5px" nz-icon nzType="warning" nzTheme="twotone"
                      twoToneColor="red"></i>Policy
                    Issuance</li>
                </ul>
              </ng-template>
            </nz-steps>
          </div>
  
        </div>
      </div>
    </div>
  </div>
  
  
    <!-- -->
  <div *ngIf="false">
    <nz-spin [nzSpinning]="getEarlyClaimPrediction" style="min-height: 100px;">
    <div class="grid grid-2x grid-gap-20">
      <div>
        <div class="grid grid-2x grid-gap-20 text-a-center p-t-20">
          <div>
            <h4>Fraud Propensity</h4>
            <!-- <nz-progress [nzPercent]="_fraudPropensity" nzType="dashboard" [nzWidth]="96" [nzFormat]="getFraudPropensity">
            </nz-progress> -->
            <nz-progress *ngIf="dataTransformService.fraudScore;else defaultFraudScore" [nzPercent]="dataTransformService.fraudScore" nzType="dashboard" [nzWidth]="96" [nzFormat]="getFraudPropensity">
            </nz-progress>
            <ng-template #defaultFraudScore>
              <nz-progress [nzPercent]="_fraudPropensity" nzType="dashboard" [nzWidth]="96" [nzFormat]="getFraudPropensity">
              </nz-progress>
            </ng-template>
          </div>
          <div>
            <h4>Early Claim Probability Score</h4>
            <!-- <nz-progress [nzPercent]="earlyClaimProbability" nzType="dashboard" [nzWidth]="96" [nzFormat]="getEarlyClaimProbability">
            </nz-progress> -->
            <nz-progress *ngIf="dataTransformService.propensityRisk;else defaultRiskScore" [nzPercent]="dataTransformService.propensityRisk" nzType="dashboard" [nzWidth]="96" [nzFormat]="getEarlyClaimProbability">
            </nz-progress>
           <ng-template #defaultRiskScore>
            <nz-progress [nzPercent]="earlyClaimProbability" nzType="dashboard" [nzWidth]="96" [nzFormat]="getRiskValue">
            </nz-progress>
            </ng-template>
            <div *ngIf="earlyClaimProbabilityYear">Possibility of claim in next: <span style="font-weight: 600;font-size: 16px;">{{earlyClaimProbabilityYear}} Year(s)</span></div>
          </div>
          <!-- <div>
            <h4>Underwriting Risk</h4>
            <nz-progress [nzPercent]="earlyClaimProbScore" nzType="dashboard" [nzWidth]="96" [nzFormat]="getClaimRisk">
            </nz-progress>
          </div> -->
        </div>
      </div>
      <div>
        <h4 class="decision-list-head list-head-top"><strong class="color-pc">Recommended</strong> action</h4>
        <div class="decision-item-highlight">
          <div>
            <h2 class="f-w-600" *ngIf="false">
              <ng-container [ngSwitch]="fraudRisk">
                <div class="color-danger" *ngSwitchCase="'High'">{{_recommendation}}</div>
                <div class="color-warning" *ngSwitchCase="'Medium'">{{_recommendation}}</div>
                <div class="color-safe" *ngSwitchDefault>{{_recommendation}}</div>
              </ng-container>
              <!-- {{'Manual Adjudication' | MMSTranslate}} -->
            </h2>
            <h2 class="f-w-600" >
               <div [ngClass]="{'color-danger' :dataTransformService.fraudScore > 60 , 'color-safe' : (dataTransformService.fraudScore < 30) }">{{dataTransformService.riskRecommendation }}</div>
            </h2>
            <p style="font-size: 12px;"*ngIf="userDetails && userDetails?.message">
              <!-- {{'* System recommended action is based on historical data, underwriting rule and ML models' | MMSTranslate}} -->
              {{userDetails.message}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </nz-spin>
  </div>
    <!-- -->
  
    <!-- OLD VERSION -- >
    <div>
      <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
  
        <h3 class="heading heading-summary m-t-20">Analysis for CLAIM #CLM0000107</h3>
  
        <h4 class="decision-list-head"><strong class="color-pc">Recommended</strong> action</h4>
  
        <div class="decision-item-highlight">
          <div>
            <h2 class="color-safe f-w-600">Refer to Investigator</h2>
            <p>
              Based on leanings from auto-adjudication rule results
            </p>
          </div>
        </div>
  
      </div>
      <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
  
        <h4 class="decision-list-head">Auto-Adjudication <strong class="color-pc">analysis</strong></h4>
  
        <div class="decisions-list">
  
          <div class="decision-item decision-item-three color-danger">
            <strong>Early Death Rule</strong>
            <span>High</span>
            <span>Failed</span>
          </div>
  
          <div class="decision-item decision-item-three color-safe">
            <span>Claim Value Rule</span>
            <span>High</span>
            <span>Passed</span>
          </div>
  
          <div class="decision-item decision-item-three color-safe">
            <span>Product Code Rule</span>
            <span>Low</span>
            <span>Passed</span>
          </div>
  
        </div>
  
      </div>
    </div>
     -->
  
  </div>